export default __webpack_public_path__ + "static/media/left paper.8b9be5a5.png";